<template>
  <div id="home">
    <my-header></my-header>

    <div class="pd20">
      <h3>Đăng ký vùng trồng</h3>
      <form v-on:submit.prevent="submitForm" v-if="ready">
        <div class="row">
          <div class="col-md-8 mb20">
            <p>
              <a class="btn btn-success" v-if="!show_location" 
              :disabled="obtaining_location" v-on:click="getCurrentLocation">Lấy vị trí vườn</a>
            </p>
            <p>Bạn cần ở vườn khi bấm Lấy vị trí vườn</p>
            <div class="mt20" v-if="show_location">
              <selectlocation
                :province="item.province_id"
                :district="item.district_id"
                :commune="item.commune_id"
                :is_get_location="true"
                :show_statellite="true"
                :frozen_position="true"
                :hide_select="true"
                :is_required="true"
                :p_location="item.location"
                @updateLocation="updateLocation"
              ></selectlocation>
            </div>

            <label  class="mt20">{{ "Cây trồng" | translate }}:</label>
            <input name="tags" placeholder="nhập tên cây trồng" value autofocus />

            <label class="mt20" >{{'Diện tích(hecta)'|translate}}:</label>
            <input
              v-model="item.area"
              ref="area"
              required
              :placeholder="'Diện tích trồng theo hecta'|translate"
              class="form-control"
            />
          </div>

        </div>

        <button class="btn btn-info mt20" type="submit" :disabled="working">
          <i v-if="working" class="fas fa-spinner fa-spin"></i>
          Đăng ký
        </button>
      </form>
    </div>
  </div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import MyHeader from '@/components/Layout/Header'
import Loading from '@/components/elements/Loading'
import selectlocation from '@/components/elements/SelectLocation'
import Tagify from '@yaireo/tagify'
export default {
  name: 'FurtherInfo',
  components: {
    MyHeader,
    Loading,
    selectlocation
  },
  data () {
    return {
      user: null,
      type: '',
      tagify: null,
      show_location: false,
      obtaining_location: false,
      working: false,
      item: null,
      ready: false
    }
  },

  methods: {
    defaultValue () {
      return {
        area: '',
        is_public: false,
        province_id: '',
        district_id: '',
        commune_id: '',
      }
    },
    getCurrentLocation(){
      let options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };
      this.obtaining_location = true;
      navigator.geolocation.getCurrentPosition((pos)=>{
        const crd = pos.coords;
        // console.log("Your current position is:");
        // console.log(`Latitude : ${crd.latitude}`);
        // console.log(`Longitude: ${crd.longitude}`);
        // console.log(`More or less ${crd.accuracy} meters.`);
        this.obtaining_location = false;
        this.item.location = {
          lat: crd.latitude,
          lng:crd.longitude
        }
        setTimeout(()=>{
          this.show_location = true
        },500)
        
      }, (error)=>{
        alert('Error', error);
      }, options);
    },
    updateLocation (data) {
      for (let key in data) {
        this.item[key] = data[key]
      }
      console.log('this.item', this.item)
    },
    getPlants () {
      Utils.getAllPlants(this, {}).then((plants) => {
        this.plants = plants

        setTimeout(() => {
          let input = document.querySelector('input[name=tags]')
          // init Tagify script on the above inputs
          let whiteList = []
          if (this.plants.length > 0) {
            whiteList = this.plants.map(function (item) {
              return { value: item.name, id: item.id, searchBy: item.unaccent_name }
            })
          }
          // console.log('whiteList', whiteList)
          this.tagify = new Tagify(input, {
            whitelist: whiteList,
            enforceWhitelist: true
          })
          if (this.item && this.item.plants) {
            let insert = this.item.plants.map(plant => {
              return {value: plant.name, id: plant.id}
            })
            this.tagify.addTags(insert)
          }
        }, 100)
      })
    },
    submitForm () {
      if (!this.item.location){
        this.$alertify.error('Bạn cần gửi thông tin vị trí của vùng trồng')
        return
      }
      let data = JSON.parse(JSON.stringify(this.item))
      data.position = data.location
      data.plant_ids = this.tagify.value.map(item => {
        return item.id
      })

      // console.log('plant_ids', plant_ids)

      let request = Utils.requestV2(this, true).post(`/plan-areas/`, data)

      this.working = true
      request
        .then((response) => {
          let data = response.data
          console.log('data', data)

          this.logicFinish()
          this.working = false
        })
        .catch((error) => {
          // this.working = false;
          Utils.showErrorMessage(this, error.response)
          this.working = false
        })
        .finally(() => {})
    },
    logicFinish () {
      this.$alertify.success('Thông tin của bạn đã được gửi')
      this.$router.push({ name: 'DownloadApps' })
    }

  },

  mounted () {
    this.type = this.$route.params.type
    this.user = Utils.getUser(this)
    if (!this.user) {
      this.$router.push({ name: 'Home' })
    }
    this.getPlants()
    this.item = this.defaultValue()
    this.ready = true
  },
  beforeDestroy () {}
}
</script>



// WEBPACK FOOTER //
// src/components/forms/FormRegisterPlanArea.vue